import React from "react";
import './Metaverse.css';
import Build from "./build/Build";
import Cases from "./cases/Cases";
import Attributes from "./attributes/Attributes";
import Implementation from "./implementation/Implementation";
import MetaverseHero from "./metaverseHero/MetaverseHero";
import Suite from "./suite/Suite";
import Features from "./features/Features";
import Testimonial from "./testimonialMetaverse/Testimonial";
import Servicemetaverse from "./servicemetaverse/Servicemetaverse";


export default function Metaverse() {
  return (
    <div className="metaverse">
        <MetaverseHero/>
        <Suite/>
        <Features/>
        <Attributes/>
        <Implementation/>
      <Cases/>
       <Build />
    <Testimonial/>
      <Servicemetaverse/>
    </div>
  );
}
